import PropTypes from "prop-types";
import SeccionWrapper from "../SeccionWrapper";
import StepEstructura from "../../FormularioPropuestaV2/steps/StepEstructura";

const SeccionEstructura = ({
  formik,
  camposIA,
  desmarcarCampoIA,
  faltantes,
}) => (
  <SeccionWrapper
    id="seccion-estructura"
    numero={4}
    titulo="Estructura de la propuesta"
    faltantes={faltantes}
  >
    <StepEstructura
      formik={formik}
      camposIA={camposIA}
      desmarcarCampoIA={desmarcarCampoIA}
    />
  </SeccionWrapper>
);

SeccionEstructura.propTypes = {
  formik: PropTypes.object.isRequired,
  camposIA: PropTypes.instanceOf(Set),
  desmarcarCampoIA: PropTypes.func,
  faltantes: PropTypes.arrayOf(PropTypes.string),
};

export default SeccionEstructura;
